import { ReferenceField } from 'react-admin'

import config from './config'
import AdvancedTextField from '../../components/AdvancedTextField'

const HubField = ({ variant, ...props }) => (
  <ReferenceField {...props}>
    <AdvancedTextField source="name" />
  </ReferenceField>
)

HubField.defaultProps = {
  reference: config.name,
  source: config.options.referenceKey,
  link: false,
}

export default HubField
